import React  from 'react'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import AppBar from '@material-ui/core/AppBar'
import Paper from '@material-ui/core/Paper'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'

import Typography from '@material-ui/core/Typography'

import { CourseLevelAdminHome } from './CourseLevelAdmin/Index'

import { SisImportHome } from './SisImport/Index'

import { SectionLevelHome } from './SectionLevelAdmin/Index'

import { ZoomComponentHome } from './ZoomComponent/Index'

import { CourseStudentsExport } from './CourseStudentsExport/Index'

import { BestTeachingAwardReport } from './BestTeachingAwardReport/Index'

import { BestTeachingAwardImport } from './BestTeachingImport/Index'

import { GroupLevelHome } from './GroupLevelAdmin/Index'

import {
  clearCoursesData,
  clearSummeryCourses,
  selectedSubAccountUpdate
} from '../actions'

import { AwsS3Manager } from './AwsS3Manager/Index'

import { SearchUsersHome } from './SearchUsers/Index'

import { ZoomCoursesHome } from './ZoomCourses/Index'

import BrowserStore from 'store'

import { CreateUsersHome } from './CreateUsers/Index'

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams,
  useRouteMatch,
  Redirect
} from 'react-router-dom'

import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'

import Navigation from './Navigation'

import { connect } from 'react-redux'
import Box from '@material-ui/core/Box'
import Zoom from '@material-ui/core/Zoom'
import Fab from '@material-ui/core/Fab'
import AddIcon from '@material-ui/icons/Add'
import { green } from '@material-ui/core/colors'
import clsx from 'clsx'
import LiveHelpIcon from '@material-ui/icons/LiveHelp'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import Tooltip from '@material-ui/core/Tooltip'

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`
  }
}

function Copyright() {
  return (
    <Typography variant='body2' color='textSecondary' align='center'>
      {`Copyright © ${new Date().getFullYear()} INSEAD All rights reserved.`}{' '}
      {`${process.env.REACT_APP_APP_VERSION}`}
    </Typography>
  )
}

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative'
  },
  layout: {
    width: 'auto',
    marginTop: theme.spacing(5),

    [theme.breakpoints.up(1000 + theme.spacing(2) * 2)]: {
      width: 1000,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  paper: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(1000 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    }
  },
  stepper: {
    padding: theme.spacing(3, 0, 5)
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1)
  },
  fab: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  },
  fabGreen: {
    color: theme.palette.common.white,
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[600]
    }
  }
}))

const MainUI = (props) => {
  const {
    data,
    clearSummeryCourses,
    clearCoursesData,
    selectedSubAccountUpdate,
    loginExpired
  } = props

  const pathName = data.router.location.pathname

  const inseadCanvasAdmin = BrowserStore.get('inseadCanvasAdmin')

  let permCourseLevelAdmin = false
  let permSisImport = false
  let permSectionEnrollment = false
  let perZoomEventRun = false
  let permAwsS3Manager = false

  let permCourseStudentsExport = false

  let permBestTeachingAward = false

  let permBestTeachingImport = false

  let permGroupLevelAdmin = false

  let permUserSearch = false

  let permZoomCourses = false
  // let permZoomTimeEditCreate = false;
  // let permZoomTimeEditDelete = false;

  let permCreateUsers = true
  // this comes from permission.json
  let permKalturaRecordingAccess = true
  if (inseadCanvasAdmin) {
    permCourseLevelAdmin = inseadCanvasAdmin?.sub_account.course_level_admin
    permSisImport = inseadCanvasAdmin?.sub_account.sis_import
    permSectionEnrollment = inseadCanvasAdmin?.sub_account.section_enrollment
    perZoomEventRun = inseadCanvasAdmin?.sub_account.zoom_update
    permGroupLevelAdmin = inseadCanvasAdmin?.sub_account.group_level_admin
    permAwsS3Manager = inseadCanvasAdmin?.sub_account.aws_s3_manager
    permCourseStudentsExport =
      inseadCanvasAdmin?.sub_account.export_course_students
    permUserSearch = inseadCanvasAdmin?.sub_account.user_search
    permBestTeachingAward = inseadCanvasAdmin?.sub_account.best_teaching_reports
    permBestTeachingImport =
      inseadCanvasAdmin?.sub_account.best_teaching_reports
    permZoomCourses = inseadCanvasAdmin?.sub_account.zoom_creation
    permCreateUsers = inseadCanvasAdmin?.sub_account.create_users
    permKalturaRecordingAccess = inseadCanvasAdmin?.sub_account.kaltura_recording_access
  }

  // function MainUI(props) {
  const classes = useStyles()
  const handleLoginExpire = () => {
    BrowserStore.remove('inseadCanvasAdmin')
    BrowserStore.remove('inseadCanvasAdminWelcome')
    window.location.reload(false)
  }

  console.log('pathName', pathName)

  const [value, setValue] = React.useState(pathName)
  const theme = useTheme()

  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  }

  const handleTabChange = (event, newValue) => {
    console.log(pathName, newValue)

    clearCoursesData([])
    clearSummeryCourses([])
    selectedSubAccountUpdate([])
    setValue(newValue)
  }

  const allTabs = [
    '/course-level-admin',
    '/sis-import',
    '/error_permission',
    '/section-level-admin',
    '/zoom-events-run',
    '/group-level-admin'
  ]

  let newRoutes = {
    aws_s3_manager: '/aws-s3-manager',
    course_student_export: '/course-student-export',
    zoom_creation: '/zoom-creation',
    user_search: '/users',
    best_teaching_award_reports: '/best-teaching-award-reports',
    best_teaching_award_reports_import_excel: '/best-teaching-award-import',
    course_level_admin: '/course-level-admin',
    sis_import: '/sis-import',
    section_level_admin: '/section-level-admin',
    zoom_event_run: '/zoom-events-run',
    group_level_admin: '/group-level-admin',
    error_permission: '/error_permission',
    create_users: '/create_user'
  }

  const NoPermComponent = () => {
    console.log('addd erro')
    return (
      <h3 style={{ textAlign: 'center' }}>
        You don't have enough permission to view this page. <br /> Please
        contact{' '}
        <a
          class='MuiTypography-root MuiLink-root MuiLink-underlineHover MuiLink-button MuiTypography-body2 MuiTypography-colorPrimary'
          href='mailto:5555-ITservicedesk@insead.edu'
        >
          {' '}
          IT Support{' '}
        </a>
      </h3>
    )
  }

  const NotFound = () => {
    return <h3 style={{ textAlign: 'center' }}> 404 page not found. </h3>
  }

  const fabs = [
    {
      color: 'primary',
      className: classes.fab,
      icon: <HelpOutlineIcon style={{ fontSize: '2rem' }} />,
      label: 'Guide',
      route: newRoutes.course_level_admin,
      link: 'https://inseadedu.sharepoint.com/:b:/s/LMSAdminGuide/EXLwgS4snGpDoqLjNQ5ByjEBg56suGfVCjUAsivFMuIrZA?e=mGSxXc'
    },
    {
      color: 'primary',
      className: classes.fab,
      icon: <HelpOutlineIcon style={{ fontSize: '2rem' }} />,
      label: 'Guide',
      route: newRoutes.section_level_admin,
      link: 'https://inseadedu.sharepoint.com/:b:/s/LMSAdminGuide/EXyB9i3f0EtKh_9QSleMKukBb8ekkqFj15Or3YYwR_xFMg?e=BA54Fx'
    },
    {
      color: 'primary',
      className: classes.fab,
      icon: <HelpOutlineIcon style={{ fontSize: '2rem' }} />,
      label: 'Guide',
      route: newRoutes.user_search,
      link: 'https://inseadedu.sharepoint.com/:b:/s/LMSAdminGuide/EU9J35ZBe7NKvH-k4PmG48ABJ6x_71_oAl8Po571JnNF7A?e=32Yhyy'
    },

    {
      color: 'primary',
      className: classes.fab,
      icon: <HelpOutlineIcon style={{ fontSize: '2rem' }} />,
      label: 'Guide',
      route: newRoutes.course_student_export,
      link: 'https://inseadedu.sharepoint.com/:b:/s/LMSAdminGuide/EebOOHd3Mx9Nsmf5TU7dg1EBKF3isMAYWcG_NrYVf6aKww?e=R2DF79'
    },

    {
      color: 'primary',
      className: classes.fab,
      icon: <HelpOutlineIcon style={{ fontSize: '2rem' }} />,
      label: 'Guide',
      route: newRoutes.zoom_creation,
      link: 'https://inseadedu.sharepoint.com/:w:/s/LMSAdminGuide/EUmxpsodQCREvB-A50xQs7oBFiSs4NYAkAv1bPuAB-36Ww?e=E984N2'
    }
  ]

  return (
    <div>
      <Navigation></Navigation>

      <Dialog
        open={loginExpired}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          {'Login session expired.'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Please click here to login again.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color='primary' onClick={handleLoginExpire} autoFocus>
            Back to login
          </Button>
        </DialogActions>
      </Dialog>

      <React.Fragment>
        <CssBaseline />

        <AppBar position='static' color='default'>
          <Tabs
            value={pathName}
            onChange={handleTabChange}
            indicatorColor='primary'
            textColor='primary'
            variant='scrollable'
            scrollButtons='auto'
            aria-label='scrollable auto tabs example'
          >
            {permCourseLevelAdmin === true ? (
              <Tab
                label='Course Enrollment'
                value={allTabs[0]}
                component={Link}
                to={allTabs[0]}
              />
            ) : null}

            {permSisImport === true ? (
              <Tab
                label='SIS Import'
                value={allTabs[1]}
                component={Link}
                to={allTabs[1]}
              />
            ) : null}

            {permSectionEnrollment === true ? (
              <Tab
                label='Section Enrollment'
                value={allTabs[3]}
                component={Link}
                to={allTabs[3]}
              />
            ) : null}

            {perZoomEventRun === true ? (
              <Tab
                label='Zoom Event Run'
                value={allTabs[4]}
                component={Link}
                to={allTabs[4]}
              />
            ) : null}

            {permGroupLevelAdmin === true ? (
              <Tab
                label='Group Enrollment'
                value={allTabs[5]}
                component={Link}
                to={allTabs[5]}
              />
            ) : null}
            {permAwsS3Manager === true ? (
              <Tab
                label='Aws S3 Icons'
                value={newRoutes.aws_s3_manager}
                component={Link}
                to={newRoutes.aws_s3_manager}
              />
            ) : null}

            {permCourseStudentsExport === true ? (
              <Tab
                label='Course Student Exports'
                value={newRoutes.course_student_export}
                component={Link}
                to={newRoutes.course_student_export}
              />
            ) : null}

            {permUserSearch === true ? (
              <Tab
                label='Search Users'
                value={newRoutes.user_search}
                component={Link}
                to={newRoutes.user_search}
              />
            ) : null}

            {permBestTeachingAward === true ? (
              <Tab
                label='Best Teaching Award Report'
                value={newRoutes.best_teaching_award_reports}
                component={Link}
                to={newRoutes.best_teaching_award_reports}
              />
            ) : null}

            {permZoomCourses === true ? (
              <Tab
                label='Zoom Creation'
                value={newRoutes.zoom_creation}
                component={Link}
                to={newRoutes.zoom_creation}
              />
            ) : null}

            {permCreateUsers === true ? (
              <Tab
                label='Create Users'
                value={newRoutes.create_users}
                to={newRoutes.create_users}
                component={Link}
              />
            ) : null}
            {permKalturaRecordingAccess === true ? (
                <Tab
                    label='KALTURA Recording Access'
                    onClick={() =>{
                      window.open(process.env.REACT_APP_KALTURA_RECORDING_ACCESS, '_blank');
                    }}
                />
            ) : null}
          </Tabs>
        </AppBar>
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Switch>
              <Route
                exact
                path='/'
                render={() => {
                  if (permCourseLevelAdmin === true) {
                    return <Redirect to={allTabs[0]} />
                  }

                  if (permSisImport === true) {
                    return <Redirect to={allTabs[1]} />
                  }

                  if (permSectionEnrollment === true) {
                    return <Redirect to={allTabs[3]} />
                  }

                  if (perZoomEventRun === true) {
                    return <Redirect to={allTabs[4]} />
                  }

                  if (permAwsS3Manager === true) {
                    return <Redirect to={newRoutes.aws_s3_manager} />
                  }

                  if (permCourseStudentsExport === true) {
                    return <Redirect to={newRoutes.course_student_export} />
                  }

                  if (permBestTeachingAward === true) {
                    return (
                      <Redirect to={newRoutes.best_teaching_award_reports} />
                    )
                  }

                  if (permBestTeachingImport === true) {
                    return (
                      <Redirect
                        to={newRoutes.best_teaching_award_reports_import_excel}
                      />
                    )
                  }

                  if (permGroupLevelAdmin === true) {
                    return <Redirect to={allTabs[4]} />
                  }

                  if (permUserSearch === true) {
                    return <Redirect to={newRoutes.user_search} />
                  }

                  if (permZoomCourses === true) {
                    return <Redirect to={newRoutes.zoom_creation} />
                  }

                  if (permCreateUsers === true) {
                    return <Redirect to={newRoutes.create_users} />
                  }

                  return <NoPermComponent />
                }}
              />

              {permCourseLevelAdmin === true ? (
                <Route
                  exact
                  path={allTabs[0]}
                  component={CourseLevelAdminHome}
                />
              ) : null}
              {permSisImport === true ? (
                <Route exact path={allTabs[1]} component={SisImportHome} />
              ) : null}

              {permSectionEnrollment === true ? (
                <Route exact path={allTabs[3]} component={SectionLevelHome} />
              ) : null}

              {perZoomEventRun === true ? (
                <Route exact path={allTabs[4]} component={ZoomComponentHome} />
              ) : null}

              {permSectionEnrollment === true ? (
                <Route path={allTabs[3]} component={SectionLevelHome} />
              ) : null}

              {permAwsS3Manager === true ? (
                <Route
                  exact
                  path={newRoutes.aws_s3_manager}
                  component={AwsS3Manager}
                />
              ) : null}

              {permCourseStudentsExport === true ? (
                <Route
                  exact
                  path={newRoutes.course_student_export}
                  component={CourseStudentsExport}
                />
              ) : null}

              {permBestTeachingAward === true ? (
                <Route
                  exact
                  path={newRoutes.best_teaching_award_reports}
                  component={BestTeachingAwardReport}
                />
              ) : null}

              {permBestTeachingAward === true ? (
                <Route
                  exact
                  path={newRoutes.best_teaching_award_reports_import_excel}
                  component={BestTeachingAwardImport}
                />
              ) : null}

              {permGroupLevelAdmin === true ? (
                <Route path={allTabs[5]} component={GroupLevelHome} />
              ) : null}

              {permUserSearch === true ? (
                <Route
                  exact
                  path={newRoutes.user_search}
                  component={SearchUsersHome}
                />
              ) : null}

              {permZoomCourses === true ? (
                <Route
                  exact
                  path={newRoutes.zoom_creation}
                  component={ZoomCoursesHome}
                />
              ) : null}

              {permCreateUsers === true ? (
                <Route
                  exact
                  path={newRoutes.create_users}
                  component={CreateUsersHome}
                />
              ) : null}

              <Route component={NotFound} />
            </Switch>

            {fabs.map((fab, index) => (
              <Zoom
                key={fab.color}
                in={value === fab.route}
                timeout={transitionDuration}
                style={{
                  transitionDelay: `${
                    value === index ? transitionDuration.exit : 0
                  }ms`
                }}
                unmountOnExit
              >
                <Tooltip title={fab.label}>
                  <Fab
                    href={fab.link}
                    target='_new'
                    aria-label={fab.label}
                    className={fab.className}
                    color={fab.color}
                  >
                    {fab.icon}
                  </Fab>
                </Tooltip>
              </Zoom>
            ))}
          </Paper>
          <Copyright />
        </main>
      </React.Fragment>
    </div>
  )
}

function mapStateToProps(state) {
  return {
    data: state,
    loginExpired: state.Main.loginExpired
  }
}

export default connect(mapStateToProps, {
  clearCoursesData,
  clearSummeryCourses,
  selectedSubAccountUpdate
})(MainUI)
